import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col } from '_zari/core'

import * as CuentaContableCrud from 'services/cuentaContable.service'

const CuentaContableFormGroup = ({ iMonedaValue, iError, iTouched, fIsSubmitting, setFieldValue }) => {
  const __zariContext = React.useContext(ZariContext)
  const [cuentasContables, setCuentasContables] = React.useState([])

  React.useEffect(() => {
    CuentaContableCrud.getCuentasContables_PorFiltros({
      prefijo: '10',
      moneda: iMonedaValue
    })
      .then(({ data }) => {
        if (data) {
          setCuentasContables(data)
          setFieldValue('cuentaContable', data[0]._id)
        }
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [iMonedaValue, __zariContext, setFieldValue])

  return (
    <Form.Group>
      <Form.Label text='CAJA/BANCO' htmlFor='select-cuentaContable' md={4} size='sm' />
      <Col md={8}>
        <Field name='cuentaContable'>
          {({ field }) => (
            <Form.Select {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-cuentaContable'>
              {cuentasContables.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.text}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableFormGroup)
